import {
  full_screen_banner_new_style
} from '@/base/widgets_data_compatible';
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  //因为不区分pc样式和mb样式，所以这里只有infor
  infor:{
    //pagination:分页器模式  arrow_btn:箭头按钮  block_btn:块级按钮
    swiper_type:'pagination',
    banner_size:{
      radio_val:'default',
      default:{
        width:'100%',
        height:'',//默认的高度是通过第一张图片宽高比计算的
      },
      custom:{
        width:'100%',
        height:'50%',
      }
    },

    backgroundSize:{
      radio_val:'default',
      default:{
        backgroundSize:'cover'
      },
      custom:{
        backgroundSize:'auto'
      }
    },

    banner_set:{
      radio_val:'default',
      default:{
        speed:0.5,//切换速度
        delay:2,//展示时间
      },
      custom:{
        speed:3,//切换速度
        delay:10,//展示时间
      }
    },

    video_height:{
      radio_val:'default',
      default:{
        height:'42%',
      },
      custom:{
        height:'30%',
      },
    },

    end_set_height:'50%',//每次的最后一次设置

    ...full_screen_banner_new_style()


  },
  listArr:{
    full_screen_banner_pattern:'banner',//banner:轮播模式， video：视频模式
    video:'https://sitecdn.71360.com/static/txys-001/image/flv.mp4',
    add_img:'default',//移动端上，添加图片的类型，默认就是用pc图片数据，其实就是用pc的col。如果是自定义，就是用移动端自己的col
    poster:'',
    animateObj:{
      value: 1,
      animate: {
        _key: 'slide'
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/widgets/full_screen_banner/style.js